import { isPast } from 'date-fns';

export const formatNumber = (num: number) => {
  return Number(num).toFixed(2);
};

export const isEventInPast = (startsAt: string) => isPast(new Date(startsAt));
